/**
 * Exit Test Mode
 *
 * Ends the test conversation, clears the persisted slice and reloads, which
 * boots the widget as the normal production one.
 */

import { resetConversation } from '@/actions/session/resetConversation';
import type { ActionEnvironment } from '@/domain/actionEnvironment';
import { reloadPage } from '@/lib/reloadPage';

export async function exitTestMode(env: ActionEnvironment): Promise<void> {
  env.logAction('testMode/exitTestMode');

  // Reset first, clear second — the opposite order silently skips the provider
  // logout. `resetConversation` only logs out while the user still has
  // credentials, and `testModeExited` drops those in the same mutation that
  // flips `active` off.
  await resetConversation(env);
  env.store.testModeMutations.testModeExited();
  reloadPage();
}
